export default __webpack_public_path__ + "static/media/graduation-hat.30e38cb2.png";